<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<dx-data-grid class="data-grid" [dataSource]="items" [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showBorders]="true">
    <dxo-paging [pageSize]="100"></dxo-paging>
    <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
    <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	<dxo-export [enabled]="true"></dxo-export>
	<dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
	<dxi-column type="buttons">
        <dxi-button hint="View" icon="fal fa-eye" [onClick]="viewRow"></dxi-button>
		<dxi-button hint="Edit" icon="fal fa-pencil" [onClick]="editRow"></dxi-button>
		<dxi-button hint="Delete" icon="fal fa-trash" [onClick]="deleteRow"></dxi-button>
    </dxi-column>
	<dxi-column dataField="userProfileId" caption="Sent To">
		<dxo-lookup [dataSource]="people" valueExpr="id" displayExpr="fullName"></dxo-lookup>
	</dxi-column>
	<dxi-column dataField="name" dataType="text" alignment="left"></dxi-column>
	<dxi-column dataField="scheduleDescription" dataType="text" alignment="left" caption="Schedule"></dxi-column>
	<dxi-column dataField="lastRunDate" dataType="date" format="dd/MM/yyyy HH:mm:ss" alignment="left"></dxi-column>
	<dxi-column dataField="nextRunDate" dataType="date" format="dd/MM/yyyy HH:mm:ss" alignment="left"></dxi-column>
</dx-data-grid>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#gridContainer' }" [(visible)]="gridLoading" [showIndicator]="true" [showPane]="true" [shading]="true"></dx-load-panel>